import './style.css';
import Cities from "./Cities";
import Projects from "./Projects";
import React, { useState } from "react";
import { useEffect, useRef } from "react";
import { useSelector } from 'react-redux';
import SearchInput from "../../SearchInput";
import SidebarHeader from "../layout/SidebarHeader";
import useViewerStore from '../../../store-zustand/viewer';
import useProjectStore from '../../../store-zustand/project';
import useSearchStore from '../../../store-zustand/searchbar';

const SidebarSearch = ({ onCreate, onClose }) => {
  const searchFragmentRef = useRef(null);
  const { viewer, setMapbox, SearchBarData: RequestSearchBarData, search_result_visibility, setsearch_result_visibility } = useViewerStore();
  const { keywords_response } = useSearchStore();
  const { GetLastRecentEditedProject } = useProjectStore();
  const [latest_projects, setlatest_projects] = useState([]);
  const loading = useSelector(state => state.profile.loading);
  const profile = useSelector(state => state.profile.profile);

  const result_title = {
    fontSize: '18px',
    fontFamily: 'Roboto',
    marginBottom: '1rem',
    color: '#E5E5E5',
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: '21px'
  }

  const handleMouseLeave = (event) => {
    setsearch_result_visibility(false);
  };

  useEffect(() => {
    const mouseTarget = searchFragmentRef.current;
    // const mouseTarget = document.querySelector('#searchfragment');
    if (mouseTarget) {
      mouseTarget.addEventListener('mouseleave', handleMouseLeave);
      // return () => {
      //   mouseTarget.removeEventListener('mouseleave', handleMouseLeave);
      // };
      return () => {
        try {
          if (mouseTarget && mouseTarget.removeEventListener) {
            mouseTarget.removeEventListener('mouseleave', handleMouseLeave);
          }
        } catch (error) {
          console.warn('Error during SidebarSearch cleanup:', error);
        }
      };
    }

    return () => {};
  }, []);

  useEffect(() => {
    let isMounted = true;
  
    (async () => {
      if (!loading && profile && localStorage.getItem("auth0_token")) {
        let latest_projects = await GetLastRecentEditedProject();
        setlatest_projects(latest_projects);
      }
      if (!isMounted) return;
    })();
  
    return () => {
      isMounted = false; // cleanup
    };
  }, [loading, profile]);

  // useEffect(async () => {
  //   if (!loading && profile && localStorage.getItem("auth0_token")) {
  //     let latest_projects = await GetLastRecentEditedProject();
  //     setlatest_projects(latest_projects);
  //   }
  // }, [loading, profile])

  return (
    <div id='searchfragment' >
      <SidebarHeader onClose={onClose} />
      <div data-tour="step-2">
        <SearchInput onCreate={onCreate} />
        {search_result_visibility &&
          <>
            <p style={result_title}>Places</p>
            <ul style={{ margin: '0 -2.5rem' }}>
              {keywords_response}
            </ul>
          </>
        }
        {!search_result_visibility && !loading && profile && <Projects projectsData={latest_projects} />}
      </div>
      <br />
      <br />
      {!search_result_visibility && <Cities />}
    </div>
  );
};

export default SidebarSearch;